import i18n from '@ps/lang'

export default {
  namespaced: true,

  state: {
    dialog: {
      visible: false,
      appendToBody: true
    },
    onCrop: null,
    loading: false,
    url: '',
    outputType: ''
  },

  mutations: {
    setLoading(state, loading) {
      state.loading = loading
    },
    openDialog(state, { url, onCrop } = {}) {
      if (!url) throw new Error(i18n.t('workbench.image.imageEditor.argumentsAreEmpty'))
      state.dialog.visible = true
      state.loading = false
      const outputType = url.split('.')[url.split('.').length - 1].indexOf('png') === -1 ? 'jpeg' : 'png'
      state.url = url
      state.outputType = outputType
      onCrop && (state.onCrop = onCrop)
    },

    closeDialog(state) {
      if (state.loading) return
      state.dialog.visible = false
      state.onCrop = null
      state.url = ''
      state.outputType = ''
    }
  },

  actions: {
  }
}
